/**
/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';

export const SignInAndUpContentWrapper = styled.div`
  align-self: center;
  max-width: clamp(200px, 100%, 400px);
  display: flex;
  flex-direction: column;
`;
